export const GET_TAGS = 'GET_TAGS';
export const GET_TAGS_SUCCESS = 'GET_TAGS_SUCCESS';
export const GET_TAGS_FAIL = 'GET_TAGS_FAIL';

export const GET_TEMPLATES_BY_TAG = 'GET_TEMPLATES_BY_TAG';
export const GET_TEMPLATES_BY_TAG_SUCCESS = 'GET_TEMPLATES_BY_TAG_SUCCESS';
export const GET_TEMPLATES_BY_TAG_FAIL = 'GET_TEMPLATES_BY_TAG_FAIL';
